import { Component, Input } from '@angular/core';

@Component({
  selector: 'pet-media-playlist',
  templateUrl: './media-playlist.component.html',
  styleUrl: './media-playlist.component.scss'
})
export class MediaPlaylistComponent {
@Input() carouselItems: any;
}
